import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FbService } from 'src/app/services/fb.service';
import { GtagService } from 'src/app/services/gtag.service';
import { DataService } from 'src/app/services/data.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'cidade-page',
  templateUrl: './cidade-page.component.html',
  styleUrls: ['./cidade-page.component.scss']
})
export class CidadePage implements OnInit {

  public apelido = null;
  public cidade = null;
  public fotos = [];
  public loader = false;
  public messageLoader = "Carragendo Serviço...";
  public response = {
    data: "",
    status: null
  };
  public macro_regiao = [];
  public regiao: any = {};
  public configuracao_loja = null;
  public ultimoServicoInserido = null;
  public produtos_relacionados = [];
  public mySubscription: Subscription;
  public destroyed = new Subject<any>();
  public destroy = false;
  public itensBreadcrumbs = [];
  public isSendAnalytics = false;
  public servicos        = [];
  
  constructor(
    private route: ActivatedRoute, 
    private api: ApiService, 
    private router: Router, 
    private app: AppService, 
    private data: DataService, 
    private gtag: GtagService, 
    private fb: FbService
  ){
    
    this.apelido = typeof (this.route.params["_value"].apelido) != "undefined" ? this.route.params["_value"].apelido : null;
  
  }
  /**
   *
   * Retorna os dados
   *
   */
  getData() {
    try {
      
      this.loader = true; 
      
      this.api.produto().cidade(this.apelido).subscribe(response => {
        this.loader = false;
        if (response.status == 1) {
          if (response.data.cidade == null) {
            this.router.navigateByUrl("/");
          }
          this.fotos    = response.data.fotos;
          this.cidade   = response.data.cidade;
          this.servicos = response.data.servicos;   
          this.response.status = 1;
          this.setItensBreadcrumbs();
          this.app.setMetaDados(this.cidade.meta_title, this.cidade.meta_description);
          setTimeout(() => {
            this.app.toTop();
          }, 500);
        }
        else {
          this.response = response;
        }
      }, (response) => {
        this.loader = false;
        let error = this.app.formatError(response);
        this.response = {
          data: error.message,
          status: 500
        };
      });
    }
    catch (e) {
    }
  }
  /***
   *
   * Seta os breadcrumbs
   *
   */
  setItensBreadcrumbs() {
    this.itensBreadcrumbs.push({
      text: "A Serra Gaaúcha",
      routerLink: "/a-serra-gaucha"
    });
    if (this.regiao != null) {
      this.itensBreadcrumbs.push({
        text: this.cidade.nome
      });
    }
  }
  /**
   *
   * Send analytics
   *
   */
  sendAnalytics() {
    
    if(!this.isSendAnalytics) {
      
      this.isSendAnalytics = true;
      
      setTimeout(() => {
        this.gtag.sendPage();
        this.fb.init();
        this.fb.pageView();
      }, 100);
    
    }

  }
  /**
   *
   * Inicializa as Funções
   *
   */
  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    
  }
  ngOnDestroy(): void {
    this.isSendAnalytics = false;
  }

}
